export default __webpack_public_path__ + "static/media/login.119ea2f6.jpg";